"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.useUserToken = void 0;
const services_1 = require("../../common/services");
function useUserToken(_a) {
    return __awaiter(this, arguments, void 0, function* ({ clientId }) {
        // This allows to run the webapp inside an app.
        // Check https://promptus-partners.atlassian.net/browse/HM-5680
        const queryParams = new URLSearchParams(window.location.search);
        const userToken = queryParams.get('userToken');
        if (userToken) {
            return userToken;
        }
        const newUser = yield services_1.apiService.createUser(clientId);
        return newUser.token;
    });
}
exports.useUserToken = useUserToken;
